function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import * as React from "react";
var SvgLandingPlansImg1 = function SvgLandingPlansImg1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 145 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155 77.5C155 120.302 120.302 155 77.5 155C34.6979 155 0 120.302 0 77.5C0 34.6979 34.6979 0 77.5 0C120.302 0 155 34.6979 155 77.5ZM80.2772 57.2139C72.7392 60.3492 57.6738 66.8386 35.081 76.6819C31.4123 78.1408 29.4904 79.5681 29.3155 80.9636C29.0198 83.3222 31.9733 84.2509 35.9953 85.5156C36.5424 85.6876 37.1093 85.8659 37.6904 86.0548C41.6474 87.341 46.9703 88.8458 49.7375 88.9056C52.2476 88.9598 55.0491 87.925 58.1421 85.8012C79.2512 71.5519 90.1479 64.3496 90.832 64.1943C91.3146 64.0848 91.9835 63.9471 92.4366 64.3498C92.8898 64.7526 92.8452 65.5154 92.7972 65.72C92.5046 66.9674 80.9108 77.746 74.911 83.324C73.0406 85.0629 71.7138 86.2964 71.4426 86.5781C70.835 87.2091 70.2158 87.806 69.6207 88.3797C65.9445 91.9236 63.1878 94.5811 69.7733 98.9209C72.9381 101.006 75.4706 102.731 77.997 104.452C80.7561 106.331 83.5081 108.205 87.0688 110.539C87.9759 111.133 88.8423 111.751 89.6862 112.353C92.8971 114.642 95.7819 116.698 99.3459 116.37C101.417 116.18 103.556 114.232 104.642 108.425C107.21 94.6995 112.256 64.9609 113.423 52.7063C113.525 51.6326 113.396 50.2586 113.293 49.6554C113.19 49.0522 112.974 48.1928 112.19 47.5566C111.262 46.8031 109.828 46.6442 109.187 46.6555C106.272 46.7069 101.8 48.2619 80.2772 57.2139Z",
    fill: "url(#paint0_linear_18202_16774)"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_18202_16774",
    x1: 9.89629e-7,
    y1: 89,
    x2: 123,
    y2: 54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0091D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0099E3",
    stopOpacity: 0.1
  }))));
};
export default SvgLandingPlansImg1;